<template>

    
    <div class="home-container" v-if="isMobile()">

        <img 
            :src="icon.title"
            id="home-title"
        />
        
        <img 
            :src="btn.home"
            id="home-btn"
            @click="navigateToNext"
        />

        <img 
            :src="icon.logo"
            id="home-logo"
        />
    </div>

    <Warning v-else />
</template>

<script>

    import { useRouter } from "vue-router";
    import { 
        toRefs, 
        reactive, 
        getCurrentInstance,
        onMounted,
        onUnmounted 
    } from "vue";

    import Warning from "@/components/warning";

    import HelperMixin from "@/mixins/helper";

    import homeBtn from "@/assets/home/button.png";
    import logoIcon from "@/assets/logo.png";
    import titleIcon from "@/assets/home/title.png";

    export default {
        name: "Home",
        mixins: [ HelperMixin ],
        components: {
            Warning
        },
        setup() {

            const HOME_BTN_ID = "#home-btn";

            onMounted(() => {
                animateHomeBtn();
            });

            onUnmounted(() => {
                clearInterval(state.timer1);
                clearInterval(state.timer2);
            });

            const router = useRouter();

            const _this = getCurrentInstance().appContext.config.globalProperties;

            const { ANIMATED, TADA } = _this.$constants.ANIMATE;

            const state = reactive({
                btn: {
                    home: homeBtn
                },
                icon: {
                    logo: logoIcon,
                    title: titleIcon
                },
                timer1: null,
                timer2: null
            });

            const navigateToNext = () => {
                
                router.replace({
                    name: "Card"
                });
            };

            const animateHomeBtn = () => {

                state.timer1 = setInterval(() => {
            
                    const homeBtn = document.querySelector(HOME_BTN_ID);

                    homeBtn.classList.add(ANIMATED, TADA);
                }, _this.$constants.TIME.ONE_SEC);

                state.timer2 = setInterval(() => {
            
                    const homeBtn = document.querySelector(HOME_BTN_ID);

                    homeBtn.classList.remove(ANIMATED, TADA);
                }, _this.$constants.TIME.ONE_SEC * 2);
            }

            return {
                ...toRefs(state),
                navigateToNext,
                animateHomeBtn
            };
        }
    }
</script>

<style lang="scss" scoped>

    #home-title {
        -webkit-backface-visibility: hidden;
        backface-visibility:hidden;
        -webkit-background-clip:content-box;
    }

    @media screen and (min-height: 800px) {

        #home-btn {
            width: 210px;
            height: auto;
        }

        #home-logo {
            width: 18rem;
            height: auto;
        }

        #home-title {
            width: 370px;
            height: auto;
        }
        
        .home-container {

            background: url(../assets/home/home.jpg) no-repeat;
            background-size: cover;
            background-position: 50% 50%;
            width: 100vw;
            height: 100vh;

            #home-btn {
                position: fixed;
                bottom: 7%;
                left: 25%;
                cursor: pointer;
            }

            #home-logo {
                position: fixed;
                bottom: 5%;
                left: calc((100% - 18rem) / 2);
            }

            #home-title {
                position: fixed;
                top: 9%;
                left: 5%;
            }
        }
    }

    @media screen and (max-height: 800px) {

        #home-btn {
            width: 10rem;
            height: auto;
        }

        #home-logo {
            width: 15rem;
            height: auto;
        }

        #home-title {
            width: 18rem;
            height: auto;

            // 消锯齿
            -webkit-backface-visibility: hidden;
            backface-visibility:hidden;
            -webkit-background-clip:content-box;
        }
        
        .home-container {
            background: url(../assets/home/home.jpg) no-repeat;
            background-size: cover;
            background-position: 50% 50%;
            width: 100vw;
            height: 100vh;

            #home-btn {
                position: fixed;
                bottom: 7%;
                left: calc((100% - 10rem) / 2);
                cursor: pointer;
            }

            #home-logo {
                position: fixed;
                left: calc((100% - 15rem) / 2);
                bottom: 3%;
            }

            #home-title {
                position: fixed;
                top: 5.3%;
                left: calc((100% - 18rem) / 2);
            }
        }
    }
</style>